import { forwardRef, type InputHTMLAttributes, type ReactNode } from "react";
import { FileInput, type InputProps } from "react-daisyui";
import { twMerge } from "tailwind-merge";

export interface InputFileProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "size"> {
  label: string | ReactNode;
  error?: string;
  size?: InputProps["size"];
  required?: boolean;
}

export const InputFile = forwardRef<HTMLInputElement, InputFileProps>(
  ({ label, error, required = false, className, id, size, ...props }, ref) => {
    const inputClasses = twMerge("file-input file-input-bordered w-full", error && "input-error", className);

    return (
      <div className="form-control relative">
        <label className="label" htmlFor={id}>
          <span className="label-text">
            {label}
            {required && "*"}
          </span>
        </label>
        <FileInput className={inputClasses} ref={ref} {...props} id={id} />
        {error && (
          <label className="label absolute -bottom-5 p-0" htmlFor={id}>
            <span className="label-text-alt text-error">{error}</span>
          </label>
        )}
      </div>
    );
  },
);
